import { Instrument } from '../../models/quote/instrument.model';
import { UtilitiesService } from '../../services/utilities.service';
import { StocksMarketAction } from './stocks-market.action';

export class StocksMarketState {
    public marketOpen?: boolean;
    public instruments: {[key: string]: Instrument};
    public pendingInstruments: string[];
    public trends: any;
    public stockHistory: any;
    public quote: any;
    public quoteInfo: any;
    public loadingQuoteHistoryPendingRequests: number;
    public quoteHistoryError: any;
    public quoteHistory: { [key: string]: { [key: number]: any[] } };
    public stockHistoryOneHour: any;
    public stockHistoryOneDay: any;
    public stockHistoryOneWeek: any;
    public stockHistoryOneMonth: any;
    public stockHistoryTwoMonths: any;
    public stockHistoryOneYear: any;
    public stockHistoryFiveYears: any;
}

export const initialState: StocksMarketState = {
    instruments: {},
    loadingQuoteHistoryPendingRequests: 0,
    marketOpen: true,
    pendingInstruments: [],
    quote: {},
    quoteInfo: {},
    quoteHistory: { },
    quoteHistoryError: null,
    stockHistory: null,
    stockHistoryFiveYears: null,
    stockHistoryOneDay: null,
    stockHistoryOneHour: null,
    stockHistoryOneMonth: null,
    stockHistoryOneWeek: null,
    stockHistoryOneYear: null,
    stockHistoryTwoMonths: null,
    trends: {},
};

export function StocksMarketReducer(state: StocksMarketState = initialState, action?: StocksMarketAction) {

    switch (action.type) {
        // mercado aberto
        case StocksMarketAction.marketOpen:
            return { ...state, ...{ marketOpen: true } };
        // mercado fechado
        case StocksMarketAction.marketClosed:
            return { ...state, ...{ marketOpen: false } };
        // instrument info
        case StocksMarketAction.gettingInstrumentInfo:
            return { ...state, ...{ pending: true, pendingInstruments: [...state.pendingInstruments, action.payload] }};
        case StocksMarketAction.getInstrumentInfoSuccess:
            return { ...state, ...{
                instruments: UtilitiesService.mergeIndexableObject(state.instruments, UtilitiesService.normalizeSecturityCategory([action.payload]), 'code'),
                        pending: state.pendingInstruments.filter((item) => item !== action.payload.code).length === 0,
                        pendingInstruments: state.pendingInstruments.filter((item) => item !== action.payload.code),
                        quote: UtilitiesService.mergeQuoteApiIndexableObject(state.quote, [
                            { 
                                Active: action.payload.code,
                                Stress: {
                                    Value: action.payload.stress.value,
                                    IsPtax: action.payload.stress.isPtax,
                                    ComposeNetEquity: action.payload.stress.composeNetEquity,
                                    DayTradeStrategyValue: action.payload.stress.dayTradeStrategyValue,
                                    DayTradeValue: action.payload.stress.dayTradeValue
                                },
                                TypeMarket: action.payload.typeMarket,
                                Market: action.payload.market,
                            }
                        ], 'Active')
                    },
                };
        case StocksMarketAction.getInstrumentInfoError:
            return { ...state, ...{
                    error: action.payload.error,
                    pending: state.pendingInstruments.filter((item) => item !== action.payload.code).length === 0,
                    pendingInstruments: state.pendingInstruments.filter((item) => item !== action.payload.code),
                },
            };

        case StocksMarketAction.gettingInstrumentsArrayInfo:
            return { ...state, ...{ pending: true, pendingInstruments: [...state.pendingInstruments, ...action.payload] }};
        case StocksMarketAction.getInstrumentsInfoByArraySuccess:
            return { ...state, ...{
                        instruments: UtilitiesService.mergeIndexableObject(state.instruments, UtilitiesService.normalizeSecturityCategory(action.payload), 'code'),
                        pending: state.pendingInstruments.filter((instrument) => !action.payload.find((item) => item.code === instrument)).length === 0,
                        pendingInstruments: state.pendingInstruments.filter((instrument) => !action.payload.find((item) => item.code === instrument)),
                    },
                };
        case StocksMarketAction.getInstrumentsInfoByArrayError:
            return { ...state, ...{
                    error: action.payload.error,
                    pending: state.pendingInstruments.filter((instrument) => !action.payload.find((item) => item.code === instrument)).length === 0,
                    pendingInstruments: state.pendingInstruments.filter((instrument) => !action.payload.find((item) => item.code === instrument)),
                },
            };

        case StocksMarketAction.getQuoteInfo:
            return { ...state, ...{ pending: true } };
        case StocksMarketAction.getQuoteInfoSuccess: {
            return { ...state, ...{ 
                    pending: false, quoteInfo: action.payload
                } 
            };
        }

        case StocksMarketAction.getTrends:
            return { ...state, ...{ pending: true } };
        case StocksMarketAction.getTrendsSuccess:
            return { ...state, ...{ pending: false, trends: UtilitiesService.mergeTrendIndexableObject(state.trends, action.payload, action.payload.Active, 'Period') } };

        case StocksMarketAction.getQuote:
            return { ...state, ...{ pending: true } };
        case StocksMarketAction.getQuoteSuccess: {
            return { ...state, ...{ 
                    pending: false, quote: UtilitiesService.mergeQuoteApiIndexableObject(state.quote,  [
                        {
                            Active: action.payload.Active,
                            PriceLastTrade: action.payload.PriceLastTrade,
                            Variation: action.payload.Variation,
                            LowestPriceDay: action.payload.LowestPriceDay,
                            HighestPriceDay: action.payload.HighestPriceDay,
                            DateTimeLastTrade: action.payload.DateTimeLastTrade,
                            Market: action.payload.Market,
                            TypeMarket: action.payload.TypeMarket,
                            ClosingPricePreviousDay: action.payload.ClosingPricePreviousDay,
                            OpeningPrice: action.payload.OpeningPrice,
                        }
                    ], 'Active') 
                } 
            };
        }

        // histórico (busca)
        case StocksMarketAction.getLastHourHistory:
        case StocksMarketAction.getLastDayHistory:
        case StocksMarketAction.getLastWeekHistory:
        case StocksMarketAction.getLastMonthHistory:
        case StocksMarketAction.getLastTwoMonthsHistory:
        case StocksMarketAction.getLastYearHistory:
        case StocksMarketAction.getLastFiveYearsHistory:
        case StocksMarketAction.getQuoteHistory:    
            return { ...state, ...{ loadingQuoteHistoryPendingRequests: state.loadingQuoteHistoryPendingRequests + 1}};

        // histórico (resultado)
        case StocksMarketAction.getLastHourHistorySuccess:
        case StocksMarketAction.getLastDayHistorySuccess:
        case StocksMarketAction.getLastWeekHistorySuccess:
        case StocksMarketAction.getLastMonthHistorySuccess:
        case StocksMarketAction.getLastTwoMonthsHistorySuccess:
        case StocksMarketAction.getLastYearHistorySuccess:
        case StocksMarketAction.getLastFiveYearsHistorySuccess:
        case StocksMarketAction.getQuoteHistorySuccess:

            return { ...state, ...{ loadingQuoteHistoryPendingRequests: state.loadingQuoteHistoryPendingRequests - 1, quoteHistory: {
                ...state.quoteHistory,
                ...{ [action.payload.code] : {...state.quoteHistory[action.payload.code], ...{ [action.payload.interval]: action.payload.data}}  }},
               },
            };

        // histórico (erro)
        case StocksMarketAction.getLastHourHistoryError:
        case StocksMarketAction.getLastDayHistoryError:
        case StocksMarketAction.getLastWeekHistoryError:
        case StocksMarketAction.getLastMonthHistoryError:
        case StocksMarketAction.getLastTwoMonthsHistoryError:
        case StocksMarketAction.getLastYearHistoryError:
        case StocksMarketAction.getLastFiveYearsHistoryError:
        case StocksMarketAction.getQuoteHistoryError: 
            return { ...state, ...{ loadingQuoteHistoryPendingRequests: state.loadingQuoteHistoryPendingRequests - 1, quoteHistoryError: action.payload}};

        case StocksMarketAction.resetQuoteHistoryState:
            return {...state, ...{ quoteHistory: {...state.quoteHistory, ...{[action.payload] : null} }} };

        default:
            return state;
    }
}
